export default __webpack_public_path__ + "static/media/news176.b3099250.jpg";